<template>
  <div id="app">
    <AppDialog></AppDialog>
    <AppLoading v-show="httpLoading" :type="'data'"></AppLoading>
    <AppHeader v-if="header"></AppHeader>
    <keep-alive :include="router" max="8">
      <router-view :style="header&&{paddingTop:'110px'}"/>
    </keep-alive>
    <Navgation :active="active" v-show="nav"></Navgation>
  </div>
</template>

<script>
  import Navgation from '@/components/Navgation/Navgation';
  import AppHeader from '@/components/AppHeader/AppHeader';
  import AppDialog from '@/components/AppDialog/AppDialog';
  import AppLoading from '@/components/AppLoading/AppLoading';
  import {mapState, mapActions} from 'vuex';
  import auth from '@/api/auth';
  import system from '@/api/system';
  export default {
    name: 'App',
    data() {
      return {
        active: '',
        nav: true,
        header: true,
      }
    },
    created(){

    },
    async mounted() {
      // sdkService.config();
      this.active = this.$route.path.split('/')[1];
      this.inIt();
    },
    computed: {
      ...mapState({
        httpLoading: state => state.system.httpLoading,
        router: state => state.system.router,
        user: state => state.user.userInfo,
      })
    },
    methods: {
      ...mapActions(['system/setUserId']),
      inIt() {
        this.nav = this.$route.meta.nav;
        this.header = this.$route.meta.header;
      },
    },
    components: {
      Navgation,
      AppHeader,
      AppDialog,
      AppLoading,
    },
    watch: {
      $route(to) {
        document.title = to.meta.title;
        this.nav = to.meta.nav;
        this.header = to.meta.header;
        this.active = to.path.split('/')[1];
        window.scrollTo(0, 0);
        // if(to.query.user_id){
        //   console.log(to.query.user_id)
        //   this['system/setUserId'](to.query.user_id);
        // }
      }
    }
  }
</script>

<style lang="scss">
  .recommend{
    text-align: center;
    position: relative;
    height: 473px;
    .goods {
      width: 702px;
      height: 390px;
    }
    .recommend-bottom{
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 110px;
      background-color: #ffeae9;
      background-image: url("/static/img/icon/首页/recommend.png");
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: 0 -1px;
      border-radius: 5px;
      padding:17px 50px 0 24px;
      color: #fff;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      .left{
        font-size: 21px;
        p{
          font-size: 25px;
          text-align: left;
        }
        .left-bottom{
          img{
            vertical-align: bottom;
          }
          margin-top: 14px;
          span:nth-child(2){
            font-size: 42px;
            font-weight: bold;
            display: inline-block;
            min-width: 163px;
            text-align: center;
          }
          a{
            text-decoration:line-through
          }
        }
      }
      .right{
        color: #f71470;
        font-size: 17px;
        .countdown{
          margin-top: 14px;
          span{
            display: inline-block;
            width: 38px;
            height: 48px;
            background: #f81370;
            border-radius: 5px;
            font-size: 22px;
            line-height: 48px;
            color: #fff;
            margin: 0 3px;
          }
        }
      }
    }
  }

  .countdown {
    margin-top: 14px;

    span {
      display: inline-block;
      width: 38px;
      height: 48px;
      background: #f81370;
      border-radius: 5px;
      font-size: 22px;
      line-height: 48px;
      color: #fff;
      margin: 0 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue